import { __assign } from '../node_modules/tslib/tslib.es6.js';
import React, { forwardRef } from 'react';
import { CheckCircleIcon } from './CheckCircleIcon.js';

var SuccessCheckCircleIcon = forwardRef(function (props, ref) {
    return React.createElement(CheckCircleIcon, __assign({ htmlColor: "#ffffff", backgroundColor: "primary" }, props, { ref: ref }));
});

export { SuccessCheckCircleIcon };
//# sourceMappingURL=SuccessCheckCircleIcon.js.map
